<template>
  <div
    class="fixed w-full bg-white z-20 border-t border-gray-12"
    style="margin-top: 56px; box-shadow: 0px 0px 8px rgba(152, 163, 190, 0.3)"
  >
    <div class="flex items-center leading-4 px-8" style="min-height: 56px">
      <a :href="newNextDomain + '/tx'">
        <BaseIconButton>
          <img src="@/assets/icons/Back2.svg" />
        </BaseIconButton>
      </a>
      <div class="flex-1 ml-10">
        <div class="flex items-center">
          <div class="w-1/2 flex items-center">
            <div
              class="text-gray-92 font-semibold ml-3"
              style="font-size: 20px; line-height: 30px"
            >
              {{ transaction.buyer_company_name }}
            </div>
          </div>
          <div class="w-1/2 flex items-center justify-end">
            <div
              v-if="transaction.transactionStatus==='contract_ok'"
              class="flex items-center text-xs leading-4 px-4 font-semibold rounded ml-4 text-green w-44 justify-center"
              style="background-color: #cff2ee; height: 1.75rem"
            >
              成約
            </div>
            <div
              v-else-if="transaction.transactionStatus==='contract_ng'"
              class="flex items-center text-xs leading-4 px-4 font-semibold rounded ml-4 w-44 justify-center"
              style="background-color: #f1f2f6; height: 1.75rem"
            >
              失注
            </div>
            <div
              v-else
              class="flex items-center text-xs leading-4 px-4 font-semibold rounded ml-4 text-coral-main w-44 justify-center"
              style="background-color: #ffe9e9; height: 1.75rem"
            >
            やりとり中
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import BaseIconButton from '@/components/BaseIconButton.vue';

export default {
  props: {
    transaction: {
      required: true,
    },
  },
  components: {
    BaseIconButton,
  },
  setup() {
    const newNextDomain = process.env.VUE_APP_NEW_NEXT_DOMAIN;
    return {
      utils,
      newNextDomain,
    };
  },
};
</script>

<style lang="scss" scoped>
.right-enter-from,
.right-leave-to {
  transform: translateX(100vw);
}

.right-enter-active,
.right-leave-active {
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1) 0ms;
}
</style>
